import React from 'react';
import { t } from 'i18next';

/**
 * Render fazında fırlayan bir hata, sınır yoksa TÜM React ağacını unmount eder → kullanıcı bembeyaz
 * bir sayfa görür ve sayfayı yenilemeden geri dönemez. Bu sınır o hatayı yakalayıp anlaşılır bir
 * ekran gösterir; hata detayı konsola ve (varsa) sunucu loguna düşer.
 *
 * Bilinçli olarak antd bileşeni kullanılmıyor: hatanın kaynağı tema/ConfigProvider tarafında ise
 * fallback ekranın kendisi de patlamasın.
 */
export default class ErrorBoundary extends React.Component
{
    state = { hasError: false, message: null };

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message ?? String(error) };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info?.componentStack);
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: 16,
                padding: 24,
                fontFamily: 'sans-serif',
                textAlign: 'center',
                color: '#2c3e50'
            }}>
                <div style={{fontSize: 20, fontWeight: 600}}>
                    {t('Something went wrong')}
                </div>
                <div style={{maxWidth: 640, color: '#7f8c8d', fontSize: 13, wordBreak: 'break-word'}}>
                    {this.state.message}
                </div>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        padding: '8px 20px',
                        border: 'none',
                        borderRadius: 4,
                        background: '#2c3e50',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: 14
                    }}
                >
                    {t('Reload')}
                </button>
            </div>
        );
    }
}
